/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsCart = {
  init: function ($section) {

    // Add settings from schema to current object
    //window.PXUTheme.jsCart = $.extend(this, window.PXUTheme.getSectionData($section));

    this.$section = $section;

    $(document).on('click', '[data-cart-page-delete]', function (e) {
      e.preventDefault();
      const lineID = $(this).data('line-item-key');
      window.PXUTheme.jsCart.removeFromCart(lineID);

      return false;
    });

    // Prevent the ajax cart form from being submitted when pressing the "Enter" key
    $('#cart_form').keydown(function(e){
      if (e.keyCode == 13) {
        e.preventDefault();
        return false;
      }
    });
  },
  /* NOTE (MG 14 Aug 2026): assets/mg-cart-patches.js replaces this method at runtime with a
     fetch() version that restores the row and shows the customer why it failed. This jQuery copy
     is deliberately left in place as the fallback if that file ever fails to load. */
  removeFromCart: function (lineID) {
    const $cartItem = window.PXUTheme.jsCart.$section.find(`[data-line-item="${lineID}"]`);

    $cartItem.css('opacity', '0.5');

    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&line=' + lineID,
      dataType: 'json',
      success: function (cart) {

        $cartItem.addClass('animated zoomOut')
        $cartItem.remove();

        window.PXUTheme.jsCart.updateView(cart, lineID);

        if (typeof window.PXUTheme.jsAjaxCart !== 'undefined') {
          window.PXUTheme.jsAjaxCart.updateView();
        }
      },
      error: function (XMLHttpRequest, textStatus) {
        var response = JSON.parse(XMLHttpRequest.responseText);
        response = response.description;
      }
    });
  },

  /* MG 14 Aug 2026: stamp for the stale-redraw guard in updateView below. */
  _viewToken: 0,

  updateView: function (cart, lineID) {

    if (cart.item_count > 0) {

      /* MG 14 Aug 2026 (Will sss): was a jQuery $.ajax with `async: false` -- a SYNCHRONOUS XHR
         for the whole /cart HTML document, fired on every cart-page quantity change and every
         line removal. Sync XHR blocks the main thread for the entire round trip: nothing paints,
         scrolls or responds until it returns, which is a large part of why a quantity change
         felt slow to register. (The other part, the full-form opacity .1 fade, is handled in
         assets/mg-cart-quantity.css.) It is also deprecated and warned about by Chrome.
         Now a promise-based fetch(). `credentials: 'same-origin'` keeps the cart cookie;
         `cache: 'no-store'` keeps the old `cache: false` behaviour (never serve a stale cart).
         fetch() does NOT reject on a 404/500 the way jQuery did, so response.ok is checked here.

         ⚠️ STALE-REDRAW GUARD (found in live testing, 14 Aug): this method re-fetches the whole
         cart page and swaps the rendered quantity input, line total and subtotal back in. Making
         it async means two redraws can be in flight at once -- and when they land out of order,
         the OLDER response repaints an old number over a newer one. Tapping + five times quickly
         left the box reading 4 while the cart really held 8. Each redraw now takes a token and
         throws its own result away if a newer redraw has started since. Sibling guard on
         jsAjaxCart.updateView; see also assets/mg-cart-patches.js section 2. */
      var viewToken = ++window.PXUTheme.jsCart._viewToken;

      fetch(window.PXUTheme.routes.cart_url || '/cart', {
        method: 'GET',
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart refresh failed: ' + response.status);
          return response.text();
        })
        .then(function (html) {

          // A newer redraw has started since this one was sent -- its result is the current truth.
          if (viewToken !== window.PXUTheme.jsCart._viewToken) return;

          if (lineID !== null) {

            const updatedItems = $(html).find('.cart__item-list .cart__card');
            const currentItems = $('.cart__item-list .cart__card');

            // Checks if BOGO applied and there is a change in the number of line items
            if (updatedItems.length != currentItems.length){
              const updatedCartList = $(html).find('.cart__item-list');
              // Re-append cart items
              $('.cart__item-list').replaceWith(updatedCartList);
            }

            $(currentItems).each(function(index, element){
              $(element).attr('data-line-item', (index + 1));
              $(element).find('[data-line-item-key]').attr('data-line-item-key', (index + 1));
            })

            const itemTotal = $(html).find(`[data-line-item="${lineID}"]`).find('.cart__total');
            const quantityInput = $(html).find(`[data-line-item="${lineID}"]`).find('.quantity-input');
            const itemPrice = $(html).find(`[data-line-item="${lineID}"]`).find('.cart__price');

            $(`[data-line-item="${lineID}"]`).find('.cart__total').replaceWith(itemTotal);
            $(`[data-line-item="${lineID}"]`).find('.quantity-input').replaceWith(quantityInput);
            $(`[data-line-item="${lineID}"]`).find('.cart__price').replaceWith(itemPrice);

          }

          const subtotal = $(html).find('.cart__subtotal-container');
          const discounts = $(html).find('.cart__discounts');
          const savings = $(html).find('.cart__total-savings');
          const totalItem = $(html).find(".cart-items_count");

          $('.cart__subtotal-container').replaceWith(subtotal);

          if (discounts.length > 0 && $('.cart__discounts').length < 1) {
            $('.cart__subtotal-container').before(discounts);
          } else {
            $('.cart__discounts').replaceWith(discounts);
          }

          if (savings.length > 0 && $('.cart__total-savings').length < 1) {
            $('.cart__subtotal-container').after(savings);
          } else {
            $('.cart__total-savings').replaceWith(savings);
          }

          $('[data-bind="itemCount"]').text(cart.item_count);
          $(".cart-page__title span").text(cart.item_count)
        })
        .catch(function () {
          // Leave the existing cart markup as-is; the line totals refresh on the next change.
        });

    } else {
      $('.cart__empty-cart-message').removeClass('is-hidden');
      $('.cart__form').addClass('is-hidden');
      $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
      $('[data-bind="itemCount"]').text('0');
    }

  },
  unload: function ($section) {
    // Clear event listeners in theme editor
    $('[data-cart-page-delete]').off();
    $('#cart_form').off();
  }
}

/******/ })()
;
$(document).ready(function(){
$(".cart-note-shipping .cart-expand-button").click(function(){
if ($(this).hasClass("active")) {
$(this).removeClass("active");
$(this)
.siblings(".accordion-contant")
.slideUp(300);
} else {
$(".cart-note-shipping .cart-expand-button").removeClass("active");
$(this).addClass("active");
$(".accordion-contant").slideUp(300);
$(this)
.siblings(".accordion-contant")
.slideDown(300);
}
});
});

/* MG 14 Aug 2026: loader for assets/mg-cart-patches.js -- the numeric quantity comparison, the
   floor-at-1 rule, the stock note, the one-request-at-a-time queue on /cart/change.js, and the
   fetch() removeFromCart. All of it lives in that one file because the CART PAGE loads this script
   and has no drawer markup at all, while every OTHER page loads z__jsAjaxCart.js for the header
   drawer -- both render quantity boxes, so both carry this same loader (the guard below means only
   one runs if they ever load together).

   >>> BUMP VERSION EVERY TIME YOU EDIT mg-cart-patches.js -- IN THIS FILE AND IN z__jsAjaxCart.js. <<<
   The URL is built by hand so it carries no Liquid asset_url fingerprint, and Shopify's CDN caches
   /assets/ hard: without a bump, an edited file keeps serving the OLD copy. Same trap as the
   @import list at the top of assets/mg-oos-gap-fix.css. */
(function () {
  var VERSION = '20260815-1';

  if (window.mgCartPatchesRequested) return;
  window.mgCartPatchesRequested = true;

  var ref = document.querySelector('script[src*="/assets/"]');
  if (!ref) return;

  var marker = '/assets/';
  var cut = ref.src.indexOf(marker);
  if (cut === -1) return;

  var script = document.createElement('script');
  script.src = ref.src.slice(0, cut + marker.length) + 'mg-cart-patches.js?v=' + VERSION;
  script.defer = true;
  document.head.appendChild(script);
})();
